import { render, staticRenderFns } from "./TotalEmployeesChart.vue?vue&type=template&id=ee4de294&"
import script from "./TotalEmployeesChart.vue?vue&type=script&lang=js&"
export * from "./TotalEmployeesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports